/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line import/newline-after-import
import { createContext, useContext, type Context } from 'react';
type BoardCreateContextProps = {
	projectId: string | undefined;
	projectAvatar?: string;
};

const initialContext: BoardCreateContextProps = {
	projectId: undefined,
	projectAvatar: undefined,
};

export const BoardCreateContext: Context<BoardCreateContextProps> =
	createContext<BoardCreateContextProps>(initialContext);

export const useBoardCreateContext = (): BoardCreateContextProps => useContext(BoardCreateContext);
